import React from 'react'
import FooterLogo from '../footer/footer-logo'
import LineStroke from './line-stroke'

const ErrorPage = ({ children, header }) => {
    return (
        <section id={header}>
            <main className="-mt-8 relative background-hero h-56 flex">
                <div className="md:relative md:w-full md:h-8 max-w-full absolute inset-y-0 right-0 w-1/2 h-full">
                    <svg className="absolute z-0 mt-[0px] md:ml-[5rem] lg:ml-[-21rem] xl:ml-[-21rem] ml-0 md:w-9/12 sm:w-7/12 w-full xl:w-full" viewBox="0 0 784 887" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M27.0735 7.70183H13.7948L20.7243 19.0291L279.833 442.578L20.7189 867.448L13.8161 878.767H27.0735H186.863H190.956L193.148 875.31L465.107 446.559L467.639 442.566L465.101 438.577L193.142 11.1493L190.949 7.70183H186.863H27.0735Z" fill="#ffffff3d" strokeWidth="14.8861"></path>
                        <path d="M334.28 7.70183H321.002L327.931 19.0291L587.04 442.578L327.926 867.448L321.023 878.767H334.28H494.07H498.163L500.355 875.31L772.314 446.559L774.846 442.566L772.308 438.577L500.349 11.1493L498.156 7.70183H494.07H334.28Z" fill="#ffffff3d" strokeWidth="14.8861"></path>
                    </svg>
                </div>

            </main>
            <div className='w-full pb-20 flex items-center justify-center -mt-32 relative z-30'>
                <div className="sm:text-[35px] sm:pt-10 flex flex-col items-center text-center text-[56px] mt-10">
                    <div className='w-44 mb-10'>
                        <LineStroke />
                    </div>
                    <p>{header}</p>

                    {children}
                </div>
            </div>
            <FooterLogo />

        </section>
    )
}

export default ErrorPage